<template>
  <b-button v-if="!loading" variant="danger" :disabled="disable" @click="create()">{{title}}</b-button>
  <b-spinner v-else class="align-middle"></b-spinner>
</template>

<script>
import JSZip from "jszip";

export default {
name:'create-zip-button',
  props: {
    title: String,
    data: Array,
    fileName: String,
    disabled: {
      type: Boolean,
      default: true
    },
    loading: Boolean,
    patents: {
      type: Boolean,
      default: false
    },
    format: {
      type: String,
      default: 'pdf'
    }
  },
  data() {
    return {
      disable: false
    }
  },
  methods: {
      create() {
        if (this.data.length > 0) {
          let zip = new JSZip();
          if (this.patents) {
            for (let i = 0; i < this.data.length; i++) {
              let docs = zip.folder(this.data[i].patent);
              for (const property in this.data[i].documentation) {
                if (this.format === 'jpg') {
                  docs.file(`${property}.jpg`, this.data[i].documentation[property], {base64: true});
                } else {
                  docs.file(`${property}.pdf`, this.data[i].documentation[property], {base64: true});
                }
              }
            }
          } else {
            let docs = zip.folder("documents");
            for (let i = 0; i < this.data.length; i++) {
              if (this.data[i].valor) {
                if (this.format === 'jpg') {
                  const byteCharacters = atob(this.data[i].valor);
                  const byteArrays = [];
                  for (
                      let offset = 0;
                      offset < byteCharacters.length;
                      offset += 512
                  ) {
                    const slice = byteCharacters.slice(offset, offset + 512);
                    const byteNumbers = new Array(slice.length);
                    for (let i = 0; i < slice.length; i++) {
                      byteNumbers[i] = slice.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    byteArrays.push(byteArray);
                  }
                  const blob = new Blob(byteArrays, {type: 'jpg'});
                  docs.file(`${this.data[i].nombre}.jpg`, blob);
                } else {
                  docs.file(`${this.data[i].nombre}.pdf`, this.data[i].valor, {base64: true});
                }
              } else if (this.data[i]) {
                if (this.format === 'jpg') {
                  const byteCharacters = atob(this.data[i]);
                  const byteArrays = [];
                  for (
                      let offset = 0;
                      offset < byteCharacters.length;
                      offset += 512
                  ) {
                    const slice = byteCharacters.slice(offset, offset + 512);
                    const byteNumbers = new Array(slice.length);
                    for (let i = 0; i < slice.length; i++) {
                      byteNumbers[i] = slice.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    byteArrays.push(byteArray);
                  }
                  const blob = new Blob(byteArrays, {type: 'jpg'});
                  docs.file(`${i}.jpg`, blob);
                } else {
                  docs.file(`${i}.pdf`, this.data[i], {base64: true});
                }
              }
            }
          }
          this.generateZip(zip)
        } else {
          this.disable = true
        }
      },
    generateZip (zip) {
      zip.generateAsync({type:"blob"})
          .then(function(content) {
            if (content.size > 118) {
              let fileURL = window.URL.createObjectURL(content, "application/zip");
              let fileLink = document.createElement("a");
              fileLink.href = fileURL;
              fileLink.setAttribute("download", "documents.zip");
              document.body.appendChild(fileLink);
              fileLink.click();
            } else {
              console.log('no hay pdfs')
            }
          });
      this.value = `Descargar Zip ${this.title}`;
    }
  },
  watch: {
    data() {
      this.data.length > 0 ? this.disable = false : this.disable = true
    }
  }
}
</script>
